import { render, staticRenderFns } from "./notifications-details.vue?vue&type=template&id=4845ee8b&scoped=true&"
import script from "./notifications-details.vue?vue&type=script&lang=js&"
export * from "./notifications-details.vue?vue&type=script&lang=js&"
import style0 from "./notifications-details.vue?vue&type=style&index=0&id=4845ee8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4845ee8b",
  null
  
)

component.options.__file = "notifications-details.vue"
export default component.exports